import React from 'react';

const CardTitle = ({ title, subTitle }) => {
  return (
    <div>
      <div className="gx-fs-xl gx-font-weight-semi-bold gx-mb-1">{title}</div>
      <div className="gx-fs-sm gx-text-grey">{subTitle}</div>
    </div>
  );
};

export default CardTitle;
